import { render, staticRenderFns } from "./PatrolTermComponent.vue?vue&type=template&id=2fae3604&scoped=true&"
import script from "./PatrolTermComponent.vue?vue&type=script&lang=js&"
export * from "./PatrolTermComponent.vue?vue&type=script&lang=js&"
import style0 from "./PatrolTermComponent.vue?vue&type=style&index=0&id=2fae3604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae3604",
  null
  
)

export default component.exports